import { TextField} from "@material-ui/core";
import React from "react";
import { useIntl } from 'react-intl';
import { useStyles } from "./Field.styles";
type Props = {
  onChange: (str: string) => void,
  onFocus?:() =>void
  placeholder: string,
  value?: string | Number,
  label?:string,
  errorTexts?:string,
  type?:any
  inputProps?:any,
  id?:string,
  className?:string,
  name?:any,
  Textlabel?:string,
  disabled?:boolean| undefined,
};
 const  InputField2=({ onChange,placeholder, value,label,errorTexts,type,inputProps,id,className,name,Textlabel,onFocus,disabled}: Props) =>{
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const [isFocused, setIsFocused] = React.useState(false);
  return (
    <div>
      {Textlabel?
      <label className={classes.lebelText}>
        {formatMessage({ id:Textlabel})}&nbsp;<span style={{color:'red'}}>*</span>
      </label>
      :null}
    <TextField
    id={id}
      type={type}
      //onFocus={() =>{onFocus;setIsFocused(true);}}
      //onBlur={() => setIsFocused(false)}
      disabled={disabled}
      name={name}
      variant="outlined"
      margin="normal"
      label={label}
      fullWidth
      required ={true}  
      onChange={event => onChange(event.target.value)}
      placeholder={placeholder}
      value={value}
      InputProps={inputProps}
      className={Textlabel?classes.marginTop4:className}
    />
    <div>
    {errorTexts && (
             <label style={{color:'red'}}>{errorTexts}</label>
            )}
        {errorTexts}
    </div>
    </div>
  );
}
export default InputField2;